import { UnobtrusiveValidationAjax } from "./UnobtrusiveValidationAjax";
import { ValidationService, ValidatableElement } from "aspnet-client-validation";
import { ExpressiveAnnotations } from "./ExpressiveAnnotations";

import "./UnobtrusiveValidation.scss";

export class UnobtrusiveValidation
{
	public Ajax: UnobtrusiveValidationAjax;
	public Ea: ExpressiveAnnotations;
	public Service: ValidationService;

	constructor(validationRoot: HTMLElement = document.body)
	{
		this.Service = new ValidationService();
		this.Service.allowHiddenFields = true;
		this.Service.debounce = 50;
		this.Service.ValidationInputCssClassName = "is-invalid"; // change from default of "input-validation-error"
		this.Service.ValidationMessageCssClassName = "invalid-feedback"; // change from default of "field-validation-error"

		this.Service.addProvider("atleastonecheckedtrue", (value, element, params) =>
		{
			if (element.tagName == "input" && element.type == "hidden")
			{
				params.rules["required"] = true;
				if (params.message)
				{
					params.messages["required"] = params.message;
				}
			}
		});

		// Override equalto only for radio groups; otherwise keep original compare behavior.
		this.Service.addProvider("equalto", (value, element, params) =>
		{
			if (!params.other) return true;

			// Replicate the library's getRelativeFormElement logic: strip leading "*."
			const selectedName = params.other.startsWith("*.") ? params.other.substring(2) : params.other;
			const form = (element as HTMLInputElement).form;
			const otherElement = form?.querySelector<HTMLInputElement>(`[name="${selectedName}"]`);
			if (!otherElement) return true;

			const inputElement = element as HTMLInputElement;
			const isRadioGroup = inputElement.type === "radio" && !!form && form.querySelectorAll(`input[name="${inputElement.name}"][type="radio"]`).length > 0;

			// Original aspnet-client-validation compare behavior
			if (!isRadioGroup)
			{
				return otherElement.value === value.toLowerCase();
			}

			// For radio groups, compare against the currently checked radio's value.
			if (inputElement.type === "radio")
			{
				const checkedRadio = form?.querySelector<HTMLInputElement>(`input[name="${inputElement.name}"]:checked`);
				return otherElement.value === (checkedRadio ? checkedRadio.value : "");
			}

			return otherElement.value === value;
		});

		this.Ajax = new UnobtrusiveValidationAjax(this.Service);
		this.Ea = new ExpressiveAnnotations(this.Service);

		this.Service.bootstrap({
			addNoValidate: true,
			watch: false,
			root: validationRoot
		});
	}

	public ResetValidation = (form: HTMLFormElement): void =>
	{
		form.querySelectorAll(`.${this.Service.ValidationInputCssClassName}`).forEach(validatableElement =>
		{
			this.Service.removeError(validatableElement as ValidatableElement);
		});
	}
}